import type { Task } from "../tasks/Task"

export type APIRequest = Task
